import {DialogTitle, Divider, Modal, ModalDialog} from "@mui/joy";
import React from "react";
import LoadingPageComponent from "../Loading/LoadingPageComponent";
import {useTranslation} from "react-i18next";

type TestSubmissionLoadingDialogProps = {
    open?: boolean,
    onClose?: () => void,
}

const TestSubmissionLoadingDialog = (props:TestSubmissionLoadingDialogProps) => {
    const {t} = useTranslation()
    return <Modal open={props.open} onClose={props.onClose}>
        <ModalDialog minWidth={"38rem"} variant="outlined" role="alertdialog">
            <LoadingPageComponent color={"primary"} loadingText={t("testSubmissionLoadingMessage")} />
        </ModalDialog>
    </Modal>
}

export default TestSubmissionLoadingDialog